import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./redux/store";
import './config/i18n';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <div>
      <Provider store={store}>
        <App />
      </Provider>
      <React.StrictMode enabled={false}></React.StrictMode>
    </div>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <div>
      <Provider store={store}>
        <App />
      </Provider>
      <React.StrictMode enabled={false}></React.StrictMode>
    </div>
  );
}

reportWebVitals();
